// extracted by mini-css-extract-plugin
export default {"slide":"Slide_slide__eoU8d","avatar":"Slide_avatar__IkSpY","userName":"Slide_userName__5OyJZ","courseTitle":"Slide_courseTitle__42f7m","text":"Slide_text__9bsiO"};